import { Icon, IconProps } from "./Icon";

export function IconLeftChevronBold(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="M18 1.34 16.56 0 6 11.97l10.56 12.02L18 22.65 8.61 12 18 1.34z" />
    </Icon>
  );
}
